import axios from 'axios';
import config from '../config/api';

// URL base de la API - backend en puerto 3000
const API_BASE_URL = config.endpoints.inventario;

// Configuración de axios para inventario
const inventoryAPI = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para agregar token de autenticación si es necesario
inventoryAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('fepast_auth_token');
    console.log('Token en localStorage:', token ? 'Presente' : 'No encontrado');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Agregando header Authorization:', `Bearer ${token.substring(0, 20)}...`);
    } else {
      console.log('No hay token para enviar en la petición');
    }
    return config;
  },
  (error) => {
    console.error('Error en interceptor de request:', error);
    return Promise.reject(error);
  }
);

// ============= PRODUCTOS =============

export const productService = {
  // Obtener todos los productos con paginación opcional
  getProducts: async (page = null, pageSize = null, nombre = null) => {
    try {
      const params = {};
      if (page !== null && page !== undefined) params.page = page;
      if (pageSize !== null && pageSize !== undefined) params.pageSize = pageSize;
      if (nombre) params.nombre = nombre;
      const response = await inventoryAPI.get('/productos', { params });
      return {
        success: true,
        data: response.data,
        message: 'Productos obtenidos exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al obtener productos'
      };
    }
  },

  // Obtener producto por ID
  getProductById: async (id) => {
    try {
      const response = await inventoryAPI.get(`/productos/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Producto obtenido exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al obtener el producto'
      };
    }
  },

  // Crear nuevo producto
  createProduct: async (productData) => {
    try {
      const response = await inventoryAPI.post('/productos', productData);
      return {
        success: true,
        data: response.data,
        message: 'Producto creado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al crear el producto'
      };
    }
  },

  // Actualizar producto
  updateProduct: async (id, productData) => {
    try {
      const response = await inventoryAPI.put(`/productos/${id}`, productData);
      return {
        success: true,
        data: response.data,
        message: 'Producto actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al actualizar el producto'
      };
    }
  },

  // Eliminar producto
  deleteProduct: async (id) => {
    try {
      const response = await inventoryAPI.delete(`/productos/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Producto eliminado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al eliminar el producto'
      };
    }
  }
};

// ============= CATEGORÍAS =============

export const categoryService = {
  // Obtener todas las categorías
  getCategories: async () => {
    try {
      const response = await inventoryAPI.get('/categorias');
      return {
        success: true,
        data: response.data,
        message: 'Categorías obtenidas exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al obtener categorías'
      };
    }
  },

  // Crear nueva categoría
  createCategory: async (categoryData) => {
    try {
      const response = await inventoryAPI.post('/categorias', categoryData);
      return {
        success: true,
        data: response.data,
        message: 'Categoría creada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al crear la categoría'
      };
    }
  },

  // Actualizar categoría
  updateCategory: async (id, categoryData) => {
    try {
      const response = await inventoryAPI.put(`/categorias/${id}`, categoryData);
      return {
        success: true,
        data: response.data,
        message: 'Categoría actualizada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al actualizar la categoría'
      };
    }
  },

  // Eliminar categoría
  deleteCategory: async (id) => {
    try {
      const response = await inventoryAPI.delete(`/categorias/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Categoría eliminada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al eliminar la categoría'
      };
    }
  }
};

// ============= UBICACIONES =============

export const locationService = {
  // Obtener ubicaciones (soporta paginación opcional)
  getLocations: async (page = null, pageSize = null, nombre = null) => {
    try {
      const params = {};
      if (page !== null && page !== undefined) params.page = page;
      if (pageSize !== null && pageSize !== undefined) params.pageSize = pageSize;
      if (nombre) params.nombre = nombre;
      const response = await inventoryAPI.get('/ubicaciones', { params });
      return {
        success: true,
        data: response.data,
        message: 'Ubicaciones obtenidas exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al obtener ubicaciones'
      };
    }
  },

  // Crear nueva ubicación
  createLocation: async (locationData) => {
    try {
      const response = await inventoryAPI.post('/ubicaciones', locationData);
      return {
        success: true,
        data: response.data,
        message: 'Ubicación creada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al crear la ubicación'
      };
    }
  },

  // Actualizar ubicación
  updateLocation: async (id, locationData) => {
    try {
      const response = await inventoryAPI.put(`/ubicaciones/${id}`, locationData);
      return {
        success: true,
        data: response.data,
        message: 'Ubicación actualizada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al actualizar la ubicación'
      };
    }
  },

  // Eliminar ubicación
  deleteLocation: async (id) => {
    try {
      const response = await inventoryAPI.delete(`/ubicaciones/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Ubicación eliminada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Error al eliminar la ubicación'
      };
    }
  }
};

// ============= SERVICIO COMBINADO =============

export const inventoryService = {
  products: productService,
  categories: categoryService,
  locations: locationService
};

export default inventoryService;